
import { connect } from 'react-redux';
import EmailTemplateDetailView from "./EmailTemplateDetailView"
import { createEmailTemplate, updateEmailTemplate, fetchEmailTemplate, fetchEmailTemplates, deleteEmailTemplate, invalidateEmailTemplates } from 'src/legacy/redux/actions/emailTemplate.jsx'  
import { showSettingsSideMenu, hideSettingsSideMenu } from 'src/legacy/redux/actions/settings';
import { selectAsset, selectCollection, invalidateAssetSelection, invalidateCollectionsSelection } from 'src/legacy/redux/actions/selection.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks';
import hasAccess from 'src/legacy/services/hasAccess';
import { uploadingFile, uploadingFileFailed, uploadingFileProgress} from 'src/legacy/redux/actions/assets';
import { uploadMedia } from 'src/legacy/redux/actions/media';

const mapStateToProps = (state, ownProps) => {

  var id = ownProps.params.id;
  var templateState = _.get(state.legacyRootReducer, `settings.emailTemplate.template[${id}]`);
  var emailTemplate = _.get(state.legacyRootReducer, `settings.emailTemplate.template[${id}]`);

  if(emailTemplate != null){
    emailTemplate = emailTemplate.item
  }

  return {
    profile: state.users.me,
    emailTemplates: _.get(state.legacyRootReducer, "settings.emailTemplate.items"),
    hasMore: _.get(state.legacyRootReducer, "settings.emailTemplate.loadMore"),
    template: emailTemplate,
    creating: _.get(state.legacyRootReducer, "settings.emailTemplate.template.creating"),
    updating: !templateState ? false : templateState.updating,
    deleting: !templateState ? false : templateState.deleting,
    loading: _.get(state, "settings.emailTemplate.template.loading"),
    fetching: !templateState ? false : templateState.fetching,
    showSettingsMenu: _.get(state.legacyRootReducer, "settings.settingsMenu.showSettingsMenu"),
    error: _.get(state.legacyRootReducer, "settings.emailTemplate.template.error"),
    theme: _.get(state.accounts, "item.theme")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      return dispatch(showSettingsSideMenu());
    },
    hideSettingsSideMenu : () => {
        return dispatch(hideSettingsSideMenu())
    },
    createEmailTemplate:(emailTemplate) => {
      return dispatch(createEmailTemplate(emailTemplate))
    },
    updateEmailTemplate: (id, emailTemplate) => {
      return dispatch(updateEmailTemplate(id, emailTemplate));
    },
    fetchEmailTemplate: (id) => {
      return dispatch(fetchEmailTemplate(id))
    },
    fetchEmailTemplates: (query, page) => {
      return dispatch(fetchEmailTemplates(query, page));
    },
    deleteEmailTemplate: (id) => {
      return dispatch(deleteEmailTemplate(id));
    },
    invalidateEmailTemplates:() => {
      return dispatch(invalidateEmailTemplates());
    },
    selectAsset:(asset) => {
      return dispatch(selectAsset(asset));
    },
    selectCollection: (collection) => {
      return dispatch(selectCollection(collection));
    },
    invalidateCollectionsSelection: (collection) => {
      return dispatch(invalidateCollectionsSelection(collection));
    },
    invalidateAssetSelection:() => {
      return dispatch(invalidateAssetSelection());
    },
    uploadingFile: (file) => {
      return dispatch(uploadingFile(file));
    },

    uploadingFileFailed: (file) => {
      return dispatch(uploadingFileFailed(file));
    },

    uploadingFileProgress: (file, progress) => {
      return dispatch(uploadingFileProgress(file, progress));
    },

    uploadMedia: (signedUrl, file, dimensions) => {
      return dispatch(uploadMedia(signedUrl, file, dimensions));
    }
  }
}

const EmailTemplateDetailPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(EmailTemplateDetailView);

// export default hasAccess(EmailTemplateDetailPage, 'email-template');
export default withUseHooks(EmailTemplateDetailPage);
